export default __webpack_public_path__ + "static/media/logo_shopserve.0298d567.png";